export default "__VITE_ASSET__J$Pn7C50__"